import React from 'react';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import './Services.scss';
import ServicesData from './ServiceData';
import Service from '../../../../components/Service/Service';

const Services = () => {
    return (
        <section className='service-section section-p'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6 section-p">
                        <SectionTitle title={`Poznaj ofertę \n Złota Centrum Zdrowia`} subTitle="Oferta"/>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                    </div>
                </div>

                <div className="services-cards section-pt">
                    {
                        ServicesData.map(singleService => <Service key={singleService.title} serviceList={singleService}/>)
                    }
                </div>
            </div>
        </section>
    );
};

export default Services;